import * as $ from "jquery"

export default function checklistHashRedirect() {
  this.urlParam = function (name) {
    const results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(
      window.location.href
    )
    return results ? results[1] : 0
  }
  $(document).ready(() => {
    switch (window.location.hash) {
      case "#api_url":
        $("#partners_service_api_url_prefix").focus()
        break

      case "#auth_url":
        $("#partners_service_oauth_authorization_url").focus()
        break

      case "#token_url":
        $("#partners_service_oauth_token_url").focus()
        break

      case "#general_description":
        $("#partners_service_description").focus()
        break

      case "#brand_color":
        $("#partners_service_brand_color").focus()
        break

      case "#home_url":
        $("#partners_service_home_url").focus()
        break

      case "#support_email":
        $("#partners_service_support_email").focus()
        break

      case "#client_id":
        $("#partners_service_oauth_client_id").focus()
        break

      case "#client_secret":
        $("#partners_service_oauth_client_secret").focus()
        break

      case "#demo_login":
        $("#partners_service_demo_account_login").focus()
        break

      case "#demo_password":
        $("#partners_service_demo_account_password").focus()
        break

      case "#date_time":
        $("input[value='Add ingredient']").click()
        break

      case "#description":
        $(
          `textarea[name="partners_${
            window.location.pathname.includes("triggers") ? "trigger" : "action"
          }[description]"]`
        ).focus()
        break

      case "#verbiage":
        $(
          `textarea[name="partners_${
            window.location.pathname.includes("triggers") ? "trigger" : "action"
          }[verbiage]"]`
        ).focus()
        break

      case "#banned_name":
        $(
          `li[data-ingredient-id=${this.urlParam(
            "ingredient_id"
          )}] > .links > a`
        ).click()
        $(document).ajaxComplete((event, request, settings) => {
          if (settings.url.includes("triggers")) {
            $("#partner_trigger_ingredient_name").focus()
          }
        })
        break

      case "#banned_note":
        $(
          `li[data-ingredient-id=${this.urlParam(
            "ingredient_id"
          )}] > .links > a`
        ).click()
        $(document).ajaxComplete((event, request, settings) => {
          if (settings.url.includes("triggers")) {
            $("#partner_trigger_ingredient_note").focus()
          }
        })
        break

      case "#banned_slug":
        $(
          `li[data-ingredient-id=${this.urlParam(
            "ingredient_id"
          )}] > .links > a`
        ).click()
        $(document).ajaxComplete((event, request, settings) => {
          if (settings.url.includes("triggers")) {
            $("#partner_trigger_ingredient_slug").focus()
          }
        })
        break

      case "#banned_example":
        $(
          `li[data-ingredient-id=${this.urlParam(
            "ingredient_id"
          )}] > .links > a`
        ).click()
        $(document).ajaxComplete((event, request, settings) => {
          if (settings.url.includes("triggers")) {
            $("#partner_trigger_ingredient_example").focus()
          }
        })
        break

      case "#banned_label":
        // not really sure if I need a query param that has a section or if
        // I should just check the window.location for the prence of '/triggers' (.includes)
        if (this.urlParam("section") === "trigger_fields") {
          $(
            `li[data-trigger-field-id=${this.urlParam(
              "section_id"
            )}] > .links > a`
          ).click()
          $(document).ajaxComplete((event, request, settings) => {
            if (settings.url.includes("triggers")) {
              $("#partner_trigger_field_name").focus()
            }
          })
        } else if (this.urlParam("section") === "action_fields") {
          $(
            `li[data-action-field-id=${this.urlParam(
              "section_id"
            )}] > .links > a`
          ).click()
          $(document).ajaxComplete((event, request, settings) => {
            if (settings.url.includes("actions")) {
              $("#partners_action_field_name").focus()
            }
          })
        }
        break

      case "#banned_helper":
        if (this.urlParam("section") === "trigger_fields") {
          $(
            `li[data-trigger-field-id=${this.urlParam(
              "section_id"
            )}] > .links > a`
          ).click()
          $(document).ajaxComplete((event, request, settings) => {
            if (settings.url.includes("triggers")) {
              $("#partner_trigger_field_helper_text").focus()
            }
          })
        } else if (this.urlParam("section") === "action_fields") {
          $(
            `li[data-action-field-id=${this.urlParam(
              "section_id"
            )}] > .links > a`
          ).click()
          $(document).ajaxComplete((event, request, settings) => {
            if (settings.url.includes("actions")) {
              $("#partners_action_field_helper_text").focus()
            }
          })
        }
        break

      case "#banned_dropdown":
        if (this.urlParam("section") === "trigger_fields") {
          $(
            `li[data-trigger-field-id=${this.urlParam(
              "section_id"
            )}] > .links > a`
          ).click()
          $(document).ajaxComplete((event, request, settings) => {
            if (settings.url.includes("triggers")) {
              $("html, body").animate(
                {
                  scrollTop: $(".dropdown-static-fields").offset().top,
                },
                200
              )
            }
          })
        } else if (this.urlParam("section") === "action_fields") {
          $(
            `li[data-action-field-id=${this.urlParam(
              "section_id"
            )}] > .links > a`
          ).click()
          $(document).ajaxComplete((event, request, settings) => {
            if (settings.url.includes("actions")) {
              $("html, body").animate(
                {
                  scrollTop: $(".dropdown-static-fields").offset().top,
                },
                200
              )
            }
          })
        }
        break
    }
  })
}
